import { render, staticRenderFns } from "./AudioPlayerController.vue?vue&type=template&id=5e0705b9&"
import script from "./AudioPlayerController.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports